import React from 'react'
import {
    StyledToggle,
    StyledLabelledToggle,
    StyledToggleSwitch,
    StyledToggleCheckbox,
} from '../../buttons/LabelledToggle/LabelledToggle.styled'

export interface LabelledToggleProps {
    checked?: boolean
    onToggle: (value: boolean) => void
    on?: string
    off?: string
    className?: string
}

export const LabelledToggle: React.FC<LabelledToggleProps> = ({
    onToggle,
    checked = false,
    on = 'on',
    off = 'off',
    className,
}) => (
    <StyledToggle className={className}>
        <StyledToggleCheckbox
            type="checkbox"
            checked={checked}
            onChange={() => onToggle(!checked)}
        />
        <StyledLabelledToggle
            onClick={(e) => {
                e.preventDefault()
                onToggle(!checked)
            }}
        >
            <StyledToggleSwitch active={checked}>{off}</StyledToggleSwitch>
            <StyledToggleSwitch active={checked} primary={true}>
                {on}
            </StyledToggleSwitch>
        </StyledLabelledToggle>
    </StyledToggle>
)

LabelledToggle.displayName = 'LabelledToggle'
